import {parseTime} from '../utils/index.js';

export default {
  formatDate(time) {
    if (time != null && time != undefined && time != '') {
      let date = new Date(time.substring(0,10));
      return parseTime(date, '{y}-{m}-{d}');
    }
  },

 // formatTimestamp(time) {
  formatTimestamp(time){
    if (time != undefined && time != null) {
      let date=time.replace(new RegExp(/-/gm) ,"/");
      date = new Date(date);
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}');
    }
  }
}



// WEBPACK FOOTER //
// ./src/filter/index.js